import { View } from 'react-native';

const UnorderedList = View;

export { UnorderedList };
